module.exports = __webpack_public_path__ + "img/navigator_d.bfaf578c.svg";